import { IPhongNamHocRequest } from '../../../models/request/danh-muc/IPhongNamHocRequest';
import { noitru_phong_namhoc } from '../../../models/response/category/noitru_phong_namhoc';
import { ePhongNamHocActionTypesIds, IPhongNamHocLoadErr, IPhongNamHocLoadStart, IPhongNamHocLoadSuccess, IPhongNamHocSelectErr, IPhongNamHocSelectStart, IPhongNamHocSelectSuccess } from '../../action-types/danh-muc/IPhongNamHocActionTypes';
import { BaseAction } from '../IBaseActionResult';

export const phongNamHocActions = {
	loadStart: (): IPhongNamHocLoadStart => BaseAction(undefined, ePhongNamHocActionTypesIds.LOAD_START),
	loadSuccess: (respone: noitru_phong_namhoc[]): IPhongNamHocLoadSuccess => BaseAction(respone, ePhongNamHocActionTypesIds.LOAD_SUCCESS),
	loadError: (messege: string): IPhongNamHocLoadErr => BaseAction(messege, ePhongNamHocActionTypesIds.LOAD_ERROR),

	selectStart: (): IPhongNamHocSelectStart => BaseAction(undefined, ePhongNamHocActionTypesIds.SELECT_START),
	selectSuccess: (respone: noitru_phong_namhoc[]): IPhongNamHocSelectSuccess => BaseAction(respone, ePhongNamHocActionTypesIds.SELECT_SUCCESS),
	selectError: (messege: string): IPhongNamHocSelectErr => BaseAction(messege, ePhongNamHocActionTypesIds.SELECT_ERROR)
};
